import React from "react"


const CheckboxField = ({ id, isChecked, label, ...style }) => 
    <div style={{ display: "flex", alignItems: "center", ...style }}>
        <input id={id} type="checkbox" checked={isChecked} readOnly />
        <label htmlFor={id} style={{ marginLeft: 3 }}>{label}</label>
    </div>


export default CheckboxField;